<ws-modal-wrapper headerLabel="Output Columns"
                  acceptLabel="Save"
                  cancelLabel="Close"
                  [loading]="loading"
                  [excludeModalStyling]="true"
                  (save)="saveAndClose()"
                  (cancel)="bsModalRef.hide()">
    @if (!loading) {
        <div style="overflow: auto; max-height: 700px;">
            @for (category of calendarWidgetFields; track category; let i = $index) {
                <div class="card panel-flat-color secondary-panel small-panel">
                    <div class="panel-flat-header small-header pointer"
                         (click)="category.showBody = !category.showBody">
                        <panel-chevron [showBody]="category.showBody"></panel-chevron>
                        <h3>{{ category.categoryName }}</h3>
                    </div>
                    @if (category.showBody) {
                        <div class="card-body">
                            <category-column-picker [category]="category" cpMode="smart"></category-column-picker>
                        </div>
                    }
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
